// Document types for 訪問看護ステーション (41 types)
export const DOC_TYPES = [
  // 1.1 申込・契約
  { id: "application", name: "訪問看護 利用申込書", category: "申込・契約" },
  { id: "important_matters", name: "重要事項説明書", category: "申込・契約" },
  { id: "contract", name: "訪問看護利用契約書", category: "申込・契約" },
  // 1.2 同意書
  { id: "consent_pi", name: "個人情報使用同意書", category: "同意書" },
  { id: "consent_emergency", name: "緊急時訪問看護同意書", category: "同意書" },
  { id: "consent_medical_share", name: "医療情報共有同意書", category: "同意書" },
  // 1.3 本人確認・保険(insurance recordsモジュールで管理)
  // 1.4 指示書(instructionsモジュールで管理)
  // 1.5 計画・アセスメント
  { id: "service_plan", name: "利用計画書(基本情報)", category: "計画・アセスメント" },
  { id: "assessment", name: "アセスメントシート", category: "計画・アセスメント" },
  { id: "care_plan_draft", name: "訪問看護計画書(案)", category: "計画・アセスメント" },
  { id: "care_plan_final", name: "訪問看護計画書(本)", category: "計画・アセスメント" },
  { id: "care_plan_psych", name: "訪問看護計画書(精神科)", category: "計画・アセスメント" },
  // 1.6 会議・連携
  { id: "service_meeting", name: "サービス担当者会議記録", category: "会議・連携" },
  { id: "meeting_other", name: "その他会議記録", category: "会議・連携" },
  { id: "discharge_coop", name: "退院時共同指導記録", category: "会議・連携" },
  { id: "multidisciplinary", name: "多職種連携記録", category: "会議・連携" },
  // 1.7 記録・報告
  { id: "monitoring", name: "モニタリング記録", category: "記録・報告" },
  { id: "nursing_report", name: "訪問看護報告書", category: "記録・報告" },
  { id: "opinion", name: "意見書", category: "記録・報告" },
  { id: "instruction_request", name: "訪問看護指示書依頼書", category: "記録・報告" },
  { id: "other_record", name: "その他記録", category: "記録・報告" },
  // 1.8 緊急・リスク
  { id: "emergency_plan", name: "緊急時対応計画書", category: "緊急・リスク" },
  { id: "accident_report", name: "事故報告書", category: "緊急・リスク" },
  { id: "hiyari_hatto", name: "ヒヤリ・ハット報告", category: "緊急・リスク" },
  { id: "complaint", name: "苦情対応記録", category: "緊急・リスク" },
  // 1.10 看取り・終了
  { id: "end_of_life_consent", name: "看取り同意書", category: "看取り・終了" },
  { id: "death_record", name: "死亡時記録", category: "看取り・終了" },
  { id: "service_end", name: "サービス終了記録", category: "看取り・終了" },
];

export const DOC_CATEGORIES = [
  "申込・契約",
  "同意書",
  "計画・アセスメント",
  "会議・連携",
  "記録・報告",
  "緊急・リスク",
  "看取り・終了",
];

export const getDocType = (id) => DOC_TYPES.find((d) => d.id === id);
